import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Heading';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "heading"
    }}>{`Heading`}</h1>
    <p>{`Extension of the Text component for headings`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Heading
  fontSize={[ 5, 6, 7 ]}
  color='primary'>
  Hello
</Heading>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      